/* Timezone — время показываем в ВЫБРАННОЙ зоне, ровно как строятся фильтры по дате */
import { inTz, nowInTz } from "../../helpers/timezone"

/* Helpers */
import { utils } from "../../helpers"

/* Translate */
import { t } from "../../translates/translate"


/* HOW MANY FACES THE PANEL HAS — /images/player/gamer1..gamer11 */
const AVATARS = 11


/* FACE OF A PLAYER — THE SAME CODE ALWAYS GETS THE SAME NUMBER
 * The picture is not stored anywhere, so it is taken from the code of the player instead of a random
 * number: otherwise every row of the same player would draw a different face on every render. */
export const getAvaIndex = (item) => {

    /* Fields */
    const code = String(item.player ? item.player : "")
    let hash = 0

    /* Hash Of The Code */
    for (let index = 0; index < code.length; index++) {
        hash = (hash * 31 + code.charCodeAt(index)) % AVATARS
    }

    /* Send Result */
    return hash
}


/* AVATAR OF A PLAYER */
export const getAvatar = (item) => {

    /* Check Tester — a test account has a face of its own */
    if (parseInt(item.isTester) === 1) {
        return utils.ava(0, "test")
    }

    /* Send Result */
    return utils.ava(getAvaIndex(item), "")
}


/* NAME OF A GAME — A TABLE MAY ALREADY BE DELETED, THEN THE SLUG IS ALL WE HAVE */
export const getGame = (item) => {

    /* Check Name */
    if (item.game) {
        return item.game
    }

    /* Check Slug */
    if (item.table) {
        return item.table
    }

    /* Send Result */
    return t("bns.noGame")
}


/* NAME OF A PLAYER — Users KEEPS THE FRESH ONE, THE ROW ITSELF MAY BE OLD */
export const getName = (item) => {

    /* Check Name */
    if (item.firstName) {
        return item.firstName
    }

    /* Send Result */
    return "—"
}


/* CURRENCY OF A ROUND */
export const getCurrency = (value) => value ? String(value).toUpperCase() : ""


/* AMOUNT THAT MAY BE MISSING */
export const isEmpty = (value) => value === null || value === undefined || value === ""


/* PLAIN NUMBER — A COUNTER IS WHOLE, ONLY THE MONEY KEEPS THE CENTS */
export const toNumber = (value) => {

    /* Fields */
    const number = parseFloat(value)

    /* Check Value */
    if (isNaN(number)) {
        return 0
    }

    /* Send Result */
    return number
}


/* A ROUND IS WON ONLY WHEN THE GAME REALLY WROTE AN AMOUNT INTO IT */
export const isWon = (item) => !isEmpty(item.win) && toNumber(item.win) > 0


/* PAYOUT OF A ROUND IN USD — win IS KEPT IN THE CURRENCY OF THE PLAYER */
export const getWinUSD = (item) => toNumber(item.win) * toNumber(item.currencyRate)


/* SHARE OF THE BET THAT WENT INTO THE JACKPOT POOL */
export const getJackpotPart = (item) => toNumber(item.dollarBonus) * toNumber(item.jackpotRatio)


/* SHARE OF THE BET THAT WENT INTO THE CASH BOX */
export const getCashPart = (item) => toNumber(item.dollarBonus) * (1 - toNumber(item.jackpotRatio))


/* PLAIN NUMBER OF THE STATS */
export const formatCount = (value) => {

    /* Fields */
    const number = parseInt(value)

    /* Check Value */
    if (isNaN(number)) {
        return "0"
    }

    /* Send Result */
    return String(number).replace(/\B(?=(\d{3})+(?!\d))/g, " ")
}


/* DAY OF A ROUND */
export const formatDay = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("DD.MM.YYYY")
}


/* TIME OF A ROUND */
export const formatTime = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("HH:mm:ss")
}


/* FULL DATE OF A ROUND */
export const formatDate = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Send Result */
    return inTz(value).format("DD.MM.YYYY HH:mm:ss")
}


/* HOW LONG AGO IT HAPPENED
 * The units are abbreviations on purpose — they need no plural agreement in any language,
 * and anything older than two months is shown as a plain date instead. */
export const formatAgo = (value) => {

    /* Check Value */
    if (!value) {
        return "-"
    }

    /* Fields */
    const minutes = nowInTz().diff(inTz(value), "minutes")

    /* Check Future — the clock of a game server may run ahead of the panel */
    if (minutes < 1) {
        return t("log.ago.now")
    }

    /* Minutes */
    if (minutes < 60) {
        return `${minutes} ${t("log.ago.minutes")} ${t("log.ago.suffix")}`
    }

    /* Hours */
    if (minutes < 60 * 24) {
        return `${Math.floor(minutes / 60)} ${t("log.ago.hours")} ${t("log.ago.suffix")}`
    }

    /* Days */
    if (minutes < 60 * 24 * 60) {
        return `${Math.floor(minutes / (60 * 24))} ${t("log.ago.days")} ${t("log.ago.suffix")}`
    }

    /* Send Result */
    return formatDay(value)
}


/* AMOUNT TYPED INSIDE THE JACKPOT SETTINGS — THE THOUSANDS ARE SPLIT WHILE THE ADMIN TYPES */
export const formatAmount = (value) => {

    /* Check Input */
    if (value === null || value === undefined || value === "") {
        return "0"
    }

    /* Fields — the spaces of the previous render are dropped before the number is read */
    const digits = String(value).replaceAll(" ", "").replace(/[^\d.]/g, "")
    const split = digits.split(".")

    /* Fields — a typed dot and its two decimals stay exactly as they were typed */
    const whole = String(parseInt(split[0]) ? parseInt(split[0]) : 0).replace(/\B(?=(\d{3})+(?!\d))/g, " ")
    const decimals = split.length > 1 ? split[1].slice(0, 2) : null

    /* Send Result */
    return decimals === null ? whole : `${whole}.${decimals}`
}


/* THE NUMBER BEHIND A TYPED AMOUNT */
export const parseAmount = (value) => {

    /* Fields */
    const total = parseFloat(String(value).replaceAll(" ", ""))

    /* Send Result */
    return isNaN(total) ? 0 : total
}
